/* eslint-disable max-lines */
/* eslint-disable max-lines-per-function */
/* eslint-disable object-property-newline */
import { Field } from "@atlaskit/form";
import Select from "@atlaskit/select";
import {
    Dispatch,
    ReactElement,
    SetStateAction,
    useEffect,
    useState,
} from "react";
import APIService from "../../services/API";
import { Insurance } from "../../types/Insurance";
import { SelectOpton } from "../../types/SelectedOption";

interface Props {
    setSelectedInsurance: Dispatch<SetStateAction<SelectOpton | null>>;
    selectedInsurance: SelectOpton | null;
}

export function InsuranceDropDown({
    setSelectedInsurance,
    selectedInsurance,
}: Props): ReactElement {
    const [insuranceList, setInsuranceList] = useState<Insurance[]>([]);

    useEffect(() => {
        APIService.HandleGetRequest<Insurance[]>(
            "/insurance/coachGetInsurances"
        ).then((res) => {
            setInsuranceList(res);
        });
    }, []);

    return (
        <div style={{ marginTop: 40 }} className="buttons-select">
            <Field name="selectedInsurance" label={"Ausgewählte Versicherung"}>
                {() => (
                    <Select
                        onChange={(option) => {
                            if (option) {
                                setSelectedInsurance(option);
                            }
                        }}
                        isMulti={false}
                        options={insuranceList.map((insurance) => ({
                            value: `${insurance.id}`,
                            label: insurance.name,
                        }))}
                        value={selectedInsurance}
                        closeMenuOnSelect={true}
                        popperProps={{
                            placement: "bottom",
                            strategy: "fixed",
                        }}
                        isLoading={false}
                    />
                )}
            </Field>
        </div>
    );
}
